module.exports = __webpack_public_path__ + "img/finance_icon.90b99b33.svg";